import React from 'react';
import { Link } from 'react-router-dom';

import {
  RenewAssignmentEnum,
  RenewKindEnum,
  RenewStatusEnum,
} from 'api/backofficeApiClient';
import { AssignmentDetailsModel } from 'utils/assignmentUtils';
import { AssignmentInfoTypes } from 'features/assignment/enums';

type Props = {
  assignmentDetails: AssignmentDetailsModel;
};

export default function RenewAssignment(props: Props) {
  const { assignmentDetails } = props;
  const {
    renewStatus,
    renewType,
    assignmentDocument,
    childAssignmentKey,
    renewKind,
  } = assignmentDetails;

  if (!assignmentDocument) return null;

  const renderStatusLink = (
    kind: RenewKindEnum,
    status: RenewStatusEnum,
    linkText: string,
  ) => {
    if (renewKind === kind && renewStatus === status) {
      return (
        <Link
          className="card-link page-status"
          to={`/assignment/${childAssignmentKey}?section=${AssignmentInfoTypes.Primary}`}
        >
          <span className="icon icon-attention-filled" />
          {linkText}
        </Link>
      );
    }
  };

  const renderStatusMessage = (
    kind: RenewKindEnum,
    status: RenewStatusEnum,
    types: RenewAssignmentEnum[],
    message: string,
  ) => {
    if (
      renewKind === kind &&
      renewStatus === status &&
      renewType &&
      types.includes(renewType)
    ) {
      return (
        <div className="page-status">
          <span className="icon icon-exchange-status" />
          {message}
        </div>
      );
    }
  };

  return (
    <>
      {renderStatusLink(
        RenewKindEnum.Rehire,
        RenewStatusEnum.ParentRenewRequest,
        'Rehire request sent',
      )}
      {renderStatusLink(
        RenewKindEnum.Renew,
        RenewStatusEnum.ParentRenewRequest,
        'Renewal request sent',
      )}
      {renderStatusMessage(
        RenewKindEnum.Renew,
        RenewStatusEnum.RenewRequest,
        [RenewAssignmentEnum.WithChanges],
        'Renewed with changes',
      )}
      {renderStatusMessage(
        RenewKindEnum.Renew,
        RenewStatusEnum.RenewRequest,
        [RenewAssignmentEnum.WithoutChanges],
        'Renewed with date change only',
      )}
      {renderStatusMessage(
        RenewKindEnum.Rehire,
        RenewStatusEnum.RenewRequest,
        [
          RenewAssignmentEnum.WithChanges,
          RenewAssignmentEnum.WithChangeCustomer,
        ],
        'Rehired with changes',
      )}
      {renderStatusMessage(
        RenewKindEnum.Rehire,
        RenewStatusEnum.RenewRequest,
        [RenewAssignmentEnum.WithoutChanges],
        'Rehired without changes, except for dates of assignment',
      )}
    </>
  );
}
